import Router from 'vue-router';
import Vue from 'vue';
import Entry from './pages/entry.vue';
import Home from './pages/home.vue';
import UserPrize from './pages/userPrize.vue';
import Rule from './pages/rule.vue';

Vue.use(Router);

export default new Router({
  routes: [
    { path: '/', name: 'entry', component: Entry },
    { path: '/home', name: 'home', component: Home },
    { path: '/prize', name: 'userPrize', component: UserPrize },
    { path: '/rule', name: 'Rule', component: Rule }
  ]
});
